<template>
  <div class="out finance_management">
    <banner />
    <!-- {{ nowindex }}？ -->
    <div class="stickybar">
      <a :style="nowindex===1 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">产品简介</a>
      <a :style="nowindex===2 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">功能介绍</a>
      <a :style="nowindex===3 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">产品优点</a>
      <a :style="nowindex===4 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">客户成功案例</a>
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text">
          <h3>智慧财务简介</h3>
          <p class="big_des">助力企业、政府构建连接/融合/共享/智能的财务平台，开启智能财务新时代，创造新价值。        </p>
          <ul class="system-content wow bounceInLeft" data-wow-duration="1s" data-wow-delay="0s">
            <li>
              <img class="setup" src="@/assets/system_1.png">
              <p>应对技术赋能挑战</p>
              <div class="desc">大数据，云计算等新技术对企业的经营管理都产生了新的变化，财务管理通过运用新技术能够创造更大的价格</div>
            </li>
            <li>
              <img class="maintain" src="@/assets/system_2.png">
              <p>减轻重复工作压力</p>
              <div class="desc">大数据，云数据</div>
            </li>
            <li>
              <img class="handle" src="@/assets/system_3.png">
              <p>克服多元核算挑战</p>
              <div class="desc">大数据，云数据</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="parttwo" ref="partii" class="function-wrap wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
      <div class="function-box">
        <p class="h1">智慧财务功能介绍</p>
        <ul class="function-content">
          <li v-for="(item, index) in financeArr" :key="index">
            <i :class="`function-${index+1}`"/>
            <p class="title1">{{ item.title }}</p>
            <p class="detail">
              {{ item.desc }}<br >
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div id="partthree" ref="partiii" class="gc_ceng gc_ceng_four wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
      <div class="ceng_thin">
        <div class="ceng_title">智慧财务的优势</div>
        <div class="ceng_box">
          <div>
            <div>
              <img alt="" src="@/assets/qq1.png" width="150" lazy="loaded">
            </div>
            <p>免安装 免维护<br>操作简单易上手</p>
          </div>
          <div>
            <div style="box-shadow:0 0 0 0; background: transparent">
              <img alt="" src="@/assets/qq2.png" width="200px" height="200px" margin-left="100px" lazy="loaded">
            </div>
            <p>报表数据云端储存<br>信息安全有保障<br></p>
          </div>
          <div>
            <div>
              <img alt="" src="@/assets/qq3.png" width="140" lazy="loaded">
            </div>
            <p>提供一体化管理平台<br>打造全新财务管理模式</p>
          </div>
        </div>
      </div>
    </div>
    <div id="partfour" >
      <p style="font-size:32px;padding-top:60px">客户成功案例</p>
      <div class="customer_success-box">
        <img src="@/assets/page_sanzi.png" alt="">
      </div>
      <h4>苏州市吴中区农业农村局：“三资系统”智慧财务系统化管理</h4>
      <p class="wuzhong_desc" style="padding-bottom:30px">苏州吴中区农业农村局联合睿泽构建“智慧财务”管理化数据平台，对吴中镇村级资金进行统一化，集中化管理。    </p>
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import Banner from '@/views/products/components/Banner'
import CircleBtn from '@/components/CircleBtn.vue'
export default {
  name: 'FinanceManagement',
  components: { Banner, CircleBtn },
  data() {
    return {
      financeArr: [
        { title: '帐套管理', desc: '新建自定义账套参数，历史账套随时查看' },
        { title: '科目管理', desc: '新建自定义账套参数，历史账套随时查看' },
        { title: '凭证管理', desc: '新建自定义账套参数，历史账套随时查看' },
        { title: '账簿管理', desc: '新建自定义账套参数，历史账套随时查看' },
        { title: '财务报表', desc: '新建自定义账套参数，历史账套随时查看' },
        { title: '', desc: '', icon: '' }
      ],
      nowindex: 1
    }
  },

  methods: {
    jump: function(x) {
      this.nowindex = x
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
h3 {
  color: #256cff; font-weight:bolder;
  margin-bottom: 25px;
}
.customer_success {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding-top: 85px;
  padding-bottom: 90px;
}
.customer_success p:nth-child(1) {
    margin: auto;
    width: auto;
    height: auto;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(6,24,40,1);
}
h4 {
  margin: 20px 0 10px
}
.customer_success .wuzhong_desc {
    margin: auto;
    margin-top: 20px;
    width: 1000px;
    height: auto;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(13,10,38,1);
    line-height: 24px;
    text-align: center;
}
.customer_success-box {
  max-width: 1200px;
  margin: 20px auto 0 auto;

}
.customer_success-box  img {
  width: 90%;
  margin: 0 auto;
  border: solid
}
.big_des {
  text-align: center;
  width: 70%;
  margin: 0 auto;
  margin-bottom: 5%;
}
#partfour {
  background: rgba(234,239,243,1);
}

.title {
  /* width: 1200px; */
  text-align: center;
  margin: 0 auto;
}

.top-text {
  padding: 5.5% 0 4% 0;
  /* max-width: 1200px; */
  /* margin: 0 auto; */
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}
.stickybar a {
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
li {
  list-style-type: none;
}
.function-wrap {
  width: 100%;
  /* height: 890px; */
  position: relative;
  /* background: url(../assets/function_bg.jpg) 50% 50% no-repeat; */
  background-size: cover;
  /* -ms-behavior: url(css/backgroundsize.min.htc);
  behavior: url(css/backgroundsize.min.htc); */
}
.function-box {
  /* width: 1210px; */
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.function-box > p.h1 {
  font-size: 32px;
  color: #333;
  text-align: center;
  line-height: 1;
  padding: 72px 0 ;
}
.function-content {
  width: 100%;
  position: relative;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
}
.function-content li {
  position: relative;
  width: 33%;
  /* width: 350px;
  height: 250px;
  float: left;
  margin-left: 40px; */
  background: #fff;
  border-radius: 5px;
  margin-bottom: 70px;

}
.function-content li:first-child,
.function-content li:first-child + li + li + li {
  margin-left: 0px;
}
.function-content li:first-child + li + li + li + li + li + li {
  margin-left: 0px;
}
.function-content li p.title1 {
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #292929;
  margin: 20px 0;
  /* padding: 100px 0 30px; */
}
.function-content li p.detail {
  text-align: center;
  line-height: 180%;
  font-size: 14px;
  color: #7f7f7f;
}
.function-content li i {
  display: block;
  width: 193px;
  height: 176px;
  margin: 0 auto;
  zoom: 0.8;
  /* position: absolute;
  left: 50%;
  margin-left: -50px;
  top: -50px; */
  border: solid 1px #BBBBBB;
  border-radius: 100%;
}
.function-content li i.function-1 {
  background: url('~@/assets/fin1.svg') no-repeat 50% 50%;
}
.function-content li i.function-2 {
  background: url('~@/assets/fun2.svg') no-repeat 50% 50%;
}
.function-content li i.function-3 {
  background: url('~@/assets/fun3.svg') no-repeat 50% 50%;
}
.function-content li i.function-4 {
  background: url('~@/assets/fun4.svg') no-repeat 50% 50%;
}
.function-content li i.function-5 {
  background: url('~@/assets/fun5.svg') no-repeat 50% 50%;
}
.function-content li i.function-6 {
  border: none;
  /* background: url('~@/assets/fun6.png') no-repeat 50% 50%; */
}

.gc_ceng.gc_ceng_four {
    padding: 70px 0 0;
    background: #fff;
    background: url('~@/assets/products-bg.714f810.png')
}

.gc_ceng .ceng_thin {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    text-align: left;
}

.gc_ceng .ceng_thin .ceng_title {
    font-size: 32px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 40px;
    margin: 0 0 20px;
    text-align: center;
}

.gc_ceng .ceng_thin .ceng_decro {
    font-size: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #666;
    line-height: 15px;
    margin: 0 0 70px;
    text-align: center;
}

.gc_ceng.gc_ceng_four .ceng_box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.gc_ceng.gc_ceng_four .ceng_box>div {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 180px;
    flex: 0 0 180px;
    margin: 0 0 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.gc_ceng.gc_ceng_four .ceng_box>div>div {
    width: 180px;
    height: 180px;
    margin: 0 0 40px;
    background: #fff;
    -webkit-box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    border-radius: 50%;
}

.gc_ceng.gc_ceng_four .ceng_box>div>p {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 34px;
}
.gc_ceng.gc_ceng_four .ceng_box>div>div>img {
    /* max-width: 100%; */
    max-height: 100%;
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
}

.title {
  /* max-width: 1200px;   */
  text-align: center;
  margin: 0 auto;
}

.practice {
  padding-bottom:60px;
}

.practice h1{
  padding: 50px 0 50px 0;
}

.practice img {
  padding: 50px 0 50px 0;
}

#solutiontext {
  color:whitesmoke;
  padding-bottom: 30px;
}

.solutionList {
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  background-color: #000413;
}

.solutionContent {
  display: flex;
  padding-top: 30px;
}

.solutionList h4 {
  margin: 0;
}

.leftList {
  width: 400px;
  text-align: left;
  margin-top: 40px;
}

.leftList p {
  font-size:26px;
}

.listItem {
  padding: 20px 100px 20px 100px;
  background-color: #000413;
}

.leftItem p{
  color: whitesmoke;
  text-align: left;
  padding: 2%;
}

.leftItem {
  display: flex;
  margin:5px;
  padding:3px;
  background: linear-gradient(to right,rgba(64, 224, 208, 1), rgba(64, 224, 208, 0));
}

.rightContent {
  /* background: url(../assets/solution3-1.97f0170.png); */
  width:780px;
  /* height: 300px; */
  margin: auto;
  text-align: left;
}

.rightContent p {
  color:whitesmoke;
  text-align:left;
}

#review2 {
  background-color:#f7fafe;
}

.system-content {
    text-align: center;
    width: 100%;
    position: relative;
    overflow: hidden;
    /* margin-bottom: 140px; */
    padding-top: 20px;
    padding-left:0;
    display: flex;
    justify-content: space-around;
}

.system-content li {
  padding-top: 20px;
    display: inline-block;
    width: 28%;
    height: 300px;
    background: rgba(247,247,247,1);
    /* margin-left: 240px; */
}

.system-content li:first-child {
  margin-left: 0px;
}

.system-content li p {
    vertical-align: bottom;
    font-size: 22px;
    color: #01010a;
    text-align: center;
    line-height: 1;
    padding-top: 24px;
    padding-bottom: 15px;
}

.system-content li .desc {
    font-size: 14px;
    color: #636a72;
    line-height: 24px;
    height: 50px;
    padding: 10px 20px;
}

/* ----------左右布局------------------------------- */

</style>>



// WEBPACK FOOTER //
// src/components/financeManagement.vue